import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import AccountReconciliationPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/AccountReconciliationPage";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AllReconciliationListPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/AccountReconciliationPage/AllReconciliationList";

function AllReconciliationList() {
  const [accountID, setAccountID] = useState();
  const [bankName, setBankName] = useState();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState();


  const { state } = useLocation();

  useEffect(() => {
    setAccountID(state.accountID);
    setBankName(state.bankName);
  }, []);

  useEffect(() => {
    handleGetAccountRencociliationList("", "", page);
  }, [page]);

  const handleGetAccountRencociliationList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.handleGetAccountReconciliation(
        state.accountID,
        text,
        sort,
        page
      );
      if (result?.success) {
        setData(result?.data?.reconciliations);
        setTotal(result?.data?.total)
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDeleteAccountReconciliation = async (reconciliationId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDeleteAccountReconciliation(
        reconciliationId
      );
      if (result?.success) {
        handleGetAccountRencociliationList("", "", page);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleUndoAccountReconciliation = async (reconciliationId) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleUnodAccountReconciliation(
        reconciliationId
      );
      if (result?.success) {
        handleGetAccountRencociliationList("", "", page);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <AllReconciliationListPage
      accountID={accountID}
      bankName={bankName}
      data={data}
      page={page}
      setPage={setPage}
      total={total}
      handleDeleteAccountReconciliation={handleDeleteAccountReconciliation}
      handleUndoAccountReconciliation={handleUndoAccountReconciliation}
    />
  );
}

export default AllReconciliationList;
